import React, { Fragment } from 'react';
import ModalHeader from '../../../common/headers/ModalHeader';
import TicketCreateContainer from '../../../../containers/individualPortal/ticket/TicketCreateContainer';
import { connect } from 'react-redux';


const CreateTicketModal = props => {
    const {
        environment,
        environment: {
            impersonation,
            impersonationDetails
        },
        modalHeaderProps,
        actions: {
            hideModal
        }

    } = props;

    const handleCloseModal = () => hideModal();
    const replacements =  { replacements: impersonation ? `${impersonationDetails.name}` : `${environment.user.firstName} ${environment.user.lastName}` };
    const updatedModalHeaderProps = { ...modalHeaderProps, modalHeaderTextData: ['modals.header.create_ticket', replacements ] };

    return (
        <Fragment>
            <ModalHeader {...updatedModalHeaderProps }/>
            <div className="gi-modal__body create-ticket-modal">
                <TicketCreateContainer handleCloseModal={handleCloseModal}/>
            </div>

        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
});

export default connect(mapStateToProps)(CreateTicketModal);